import _hexToRgba from 'hex-to-rgba'
const hexToRgba = (c, opacity) => {
  const color = c.replace('#', '')
  return _hexToRgba(color, opacity)
}

export default hexToRgba
